import { useToggleState } from 'shared/hooks'
import { Box, Checkbox, FormControlLabel } from '@mui/material'
import { OutlinedButton } from 'shared/ui'
import React from 'react'

export function FilterTypes({
  allTypes,
  filteredTypes,
  onFilterChange,
}: {
  filteredTypes: string[]
  allTypes: string[]
  onFilterChange: (t: string, filtered: boolean) => void
}) {
  const [showFilters, setShowFilters] = useToggleState(false)
  return (
    <Box padding="10px">
      <Box>
        <OutlinedButton onClick={() => setShowFilters(!showFilters)}>
          Filtered Content
        </OutlinedButton>{' '}
      </Box>
      {showFilters && (
        <Box padding="10px">
          {allTypes.map((t) => {
            const checkbox = (
              <Checkbox
                sx={{ p: 0 }}
                checked={filteredTypes.includes(t)}
                onChange={(e) => onFilterChange(t, e.target.checked)}
              />
            )
            return (
              <Box key={t}>
                <FormControlLabel control={checkbox} label={t} />
              </Box>
            )
          })}
        </Box>
      )}
    </Box>
  )
}
